import React, { Component } from 'react'
import i18n from 'simple-react-i18n'
import { Outlet } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GlobalParametersDto from 'administration/dto/GlobalParameterDto'
import UserDto from 'administration/components/user/dto/UserDto'
import AdministrationAction from 'administration/actions/AdministrationAction'
import { Box } from '@mui/material'
import { H_PLUVIO_CAMPAIGN, H_PLUVIO_DASHBOARD, H_PLUVIO_EXPORT, H_PLUVIO_GRAPHIC,
    H_PLUVIO_IMPORT, H_PLUVIO_OPTIONS, H_PLUVIO_SITUATION } from 'account/constants/AccessRulesConstants'
import { links } from 'quality/constants/StationsConstants'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import User from 'account/dto/User'
import { IMPORT_TYPE } from 'traitements/constants/TraitementConstants'

const IMPORT_PLUVIO = 'importPluvio'
class PluviometersApp extends Component {
    componentDidMount() {
        const { globalParameters } = this.props
        if (!globalParameters.length) {
            this.props.fetchGlobalParameters()
        }
    }

    getLink = (linkName) => {
        const link = links[linkName]
        return {
            ...link,
            href: link.href || `/pluviometry/${link.hrefName || linkName}`,
            name: i18n[link.i18n],
            state: linkName === IMPORT_PLUVIO ? { hasToOpen: true, initialType: IMPORT_TYPE.PLUVIO_PORTAIL } : undefined,
        }
    }

    getLinksHabilitations = () => {
        return [
            ...[
                { habilitation: H_PLUVIO_DASHBOARD, linkName: 'dashboard' },
                { habilitation: H_PLUVIO_IMPORT, linkName: 'importPluvio' },
                { habilitation: H_PLUVIO_EXPORT, linkName: 'export' },
                { habilitation: H_PLUVIO_SITUATION, linkName: 'integrationOverview' },
                { habilitation: H_PLUVIO_CAMPAIGN, linkName: 'campaign' },
                { habilitation: H_PLUVIO_GRAPHIC, linkName: 'graphic' },
                { habilitation: H_PLUVIO_OPTIONS, linkName: 'pluviometryOptions' },
                { habilitation: H_PLUVIO_SITUATION, linkName: 'mapSituations' },
            ].filter(l => componentHasHabilitations(l.habilitation)),
        ]
    }

    render() {
        const baseLinks = this.getLinksHabilitations().filter(l => l)
        const navBarLinks = baseLinks.map(a => this.getLink(a.linkName))
        return (
            <Box>
                <FixedSlideNav links={navBarLinks} />
                <Box className='content-page padding-1 fullscreen'>
                    <BoundaryError>
                        <Outlet />
                    </BoundaryError>
                </Box>
            </Box>
        )
    }
}

PluviometersApp.propTypes = {
    children: PropTypes.element,
    getLink: PropTypes.func,
    accountUser: PropTypes.instanceOf(User),
    globalParameters: PropTypes.arrayOf(PropTypes.instanceOf(GlobalParametersDto)),
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserDto)),
    fetchGlobalParameters: PropTypes.func,
}

const mapStateToProps = store => ({
    accountUser: store.AccountReducer.accountUser,
    globalParameters: store.AdministrationReducer.globalParameters,
    users: store.UserReducer.users,
})

const mapDispatchToProps = {
    fetchGlobalParameters: AdministrationAction.fetchGlobalParameters,
}

export default connect(mapStateToProps, mapDispatchToProps)(PluviometersApp)
